"use client";

import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
export default function DoctoraliaBooking() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Clear any previous child nodes in the container (e.g. from strict-mode double run)
    container.innerHTML = "";

    // Create the plain <a> tag expected by the Docplanner/Doctoralia widget script
    const anchor = document.createElement("a");
    anchor.className = "zl-url";
    anchor.id = "zl-url";
    anchor.rel = "nofollow";
    anchor.href = "https://www.doctoralia.es/perfil/maria-del-carmen-soto-jimenez";
    anchor.setAttribute("data-zlw-doctor", "maria-del-carmen-soto-jimenez");
    anchor.setAttribute("data-zlw-type", "big");
    anchor.setAttribute("data-zlw-opinion", "false");
    anchor.setAttribute("data-zlw-hide-branding", "true");
    anchor.setAttribute("data-zlw-saas-only", "true");
    anchor.setAttribute("data-zlw-a11y-title", "Widget de reserva de citas médicas");
    anchor.textContent = "Reserve una cita";
    container.appendChild(anchor);

    // Remove any existing script tag to guarantee re-execution
    const existingScript = document.getElementById("zl-widget-s");
    if (existingScript) {
      existingScript.remove();
    }
    const script = document.createElement("script");
    script.src = "https://platform.docplanner.com/js/widget.js";
    script.id = "zl-widget-s";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const scriptToRemove = document.getElementById("zl-widget-s");
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);
  return <section id="doctoraliabooking" className="bg-background pt-24 pb-4 md:pb-6 px-6">
      <div className="mx-auto max-w-4xl flex flex-col items-center text-center">
        <motion.div initial={{
        opacity: 0,
        height: 0
      }} whileInView={{
        opacity: 1,
        height: 48
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="w-1 bg-primary mb-6 rounded-lg" />

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: "easeOut"
      }} className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
          Reserva tu cita online
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3,
        ease: "easeOut"
      }} className="text-muted-foreground max-w-2xl mb-8">
          Gestiona tu consulta de forma rápida y segura a través de nuestro portal integrado. Selecciona el tratamiento, la fecha y la hora que mejor se adapten a tu disponibilidad.
        </motion.p>

        <div className="w-full self-stretch text-left [&_iframe]:w-full [&_iframe]:border-0">
          <div ref={containerRef} className="w-full" />
        </div>
      </div>
    </section>;
}